import { render, staticRenderFns } from "./LeftPanel.vue?vue&type=template&id=1fc55dfa&scoped=true&"
import script from "./LeftPanel.vue?vue&type=script&lang=js&"
export * from "./LeftPanel.vue?vue&type=script&lang=js&"
import style0 from "./LeftPanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LeftPanel.vue?vue&type=style&index=1&id=1fc55dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc55dfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fc55dfa')) {
      api.createRecord('1fc55dfa', component.options)
    } else {
      api.reload('1fc55dfa', component.options)
    }
    module.hot.accept("./LeftPanel.vue?vue&type=template&id=1fc55dfa&scoped=true&", function () {
      api.rerender('1fc55dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/LeftPanel.vue"
export default component.exports